import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { fetchApi, JsonResponse } from '../../services/api';
import Invoice from '../Invoices/Invoice';
import { InvoiceData } from '../Invoices';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { NumericTextBox } from '@progress/kendo-react-inputs';
import InvoiceDropDown, { InvoiceSearchResult } from '../InvoiceDropDown';
import { DatePicker } from '@progress/kendo-react-dateinputs';
import LoadingButton from '../LoadingButton';
import { FacilitySearchResult } from '../FacilityComboBox';
import * as $ from 'jquery';
const DocumentTitle = require('react-document-title');

type Props = RouteComponentProps<{
    invoiceId: string;
}>;

type State = {
    invoiceId: number;
    invoice: InvoiceData | null;
    isLoading: boolean;
    facilities: FacilitySearchResult[];
    isSaving: boolean;
    validation: boolean;
    accountId: number;

    altInvoiceNum: string;
    facilityID: undefined|number;
    source: undefined|number;
    amount: number | null;
    comment: string;
    date: Date | null;
    chargeDescription: string;
    publishableKey: string;
}

export default class AccountInvoice extends React.Component<Props, State> {
    paymentTypes = [
        { text: 'Cash', value: 0 },
        { text: 'Cheque', value: 1 },
        { text: 'e-Transfer', value: 2 },
        { text: 'Credit Card', value: 3 },
        { text: 'Discount', value: 5 }
    ];

    constructor(props: Props) {
        super(props);

        this.state = {
            invoiceId: 0,
            invoice: null,
            isLoading: false,
            facilities: [],
            isSaving: false,
            validation: false,
            accountId: 0,

            altInvoiceNum: '',
            facilityID: undefined,
            source: -1,
            amount: 0,
            comment: '',
            date: new Date(),
            chargeDescription: '',
            publishableKey: '',
        };

        this.chargeCreditCard = this.chargeCreditCard.bind(this);
        this.saveAltInvoiceNum = this.saveAltInvoiceNum.bind(this);
        this.save = this.save.bind(this);
        this.handleFacilityChange = this.handleFacilityChange.bind(this);
        this.handleSourceChange = this.handleSourceChange.bind(this);
        this.emailInvoice = this.emailInvoice.bind(this);
        this.reviseInvoice = this.reviseInvoice.bind(this);
        this.requestInvoice = this.requestInvoice.bind(this);
    }

    public render() {
        return <React.Fragment>
            <DocumentTitle title="Invoice" />
            <div className="form-row py-2 d-print-none">
                <div className="col-auto ml-auto">
                    <button role="button" className="btn btn-warning" onClick={() => confirm("Revise Invoice?") && this.reviseInvoice()}>Revise Invoice</button>
                    &nbsp;
                    <button role="button" className="btn btn-primary" onClick={() => confirm("Email Invoice PDF?") && this.emailInvoice()}>Email Invoice</button>
                    &nbsp;
                    <button role="button" className="btn btn-primary" onClick={() => { window.print() }}>Print Invoice</button>
                    &nbsp;
                    <button role="button" className="btn btn-primary" data-toggle="modal" data-target=".bd-example-modal-lg">Add Payment</button>
                    &nbsp;
                    {this.state.invoice &&
                        <button role="button" className="btn btn-primary" data-toggle="modal" data-target=".bd-altinvoice-modal-lg">{(this.state.invoice.AltInvoiceNum) ? "Change Alt. Invoice #" : "Add Alt. Invoice #"}</button>
                    }
                </div>
            </div>
            <div id="paymentModal" className="modal fade bd-example-modal-lg" tabIndex={-1} role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Payment</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <DropDownList
                                    data={this.state.facilities}
                                    textField={'Name'}
                                    defaultItem={{ Name: 'Facility', ID: -1 }}
                                    value={this.state.facilities.find(x => x.FacilityId === this.state.facilityID)}
                                    onChange={this.handleFacilityChange}
                                />
                                {this.state.validation && (this.state.facilityID === -1 || this.state.facilityID === undefined) && <p className="error-msg">Please select Facility</p>}
                            </div>
                            <div className="form-group">
                                <DropDownList
                                    data={this.paymentTypes}
                                    textField={'text'}
                                    defaultItem={{ text: 'Payment Type', value: -1 }}
                                    value={this.paymentTypes.find(x => x.value === this.state.source)}
                                    onChange={this.handleSourceChange}
                                />
                                {this.state.validation && (this.state.source === -1 || this.state.source === undefined) && <p className="error-msg">Please select Payment Type</p>}
                            </div>
                            <div className="form-group">
                                {this.state.invoice &&
                                    <NumericTextBox
                                        defaultValue={this.state.amount}
                                        format="c2"
                                        min={0}
                                        value={this.state.amount}
                                        onChange={(e) => this.setState({ amount: e.value })}
                                    />
                                }
                                {this.state.validation && !this.state.amount && <p className="error-msg">Please enter Amount</p>}
                            </div>
                            <div className="form-group">
                                {this.state.accountId !== 0 &&
                                    <InvoiceDropDown
                                        callbackFromParent={this.myInvoiceCallback}
                                        accountId={this.state.accountId}
                                        className={"form-control"}
                                        value={this.state.invoiceId}
                                    />
                                }
                            </div>
                            <div className="form-group">
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Description of Charge"
                                    value={this.state.chargeDescription}
                                    onChange={(e) => this.setState({ chargeDescription: e.target.value })}
                                />
                            </div>
                            <div className="form-group">
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Cheque #, etc"
                                    value={this.state.comment}
                                    onChange={(e) => this.setState({ comment: e.target.value })}
                                />
                            </div>
                            <div className="form-group">
                                <DatePicker
                                    format="MM/dd/yyyy"
                                    formatPlaceholder="formatPattern"
                                    value={this.state.date}
                                    onChange={(e) => this.setState({ date: e.value })}
                                />
                                {this.state.validation && this.state.date === null && <p className="error-msg">Please enter Date</p>}
                            </div>
                            <LoadingButton className="btn btn-success" onClick={this.save} isLoading={this.state.isSaving}>Add Payment</LoadingButton>
                            {/* Only display the credit card button if they have a publishable key (stripe account) */}
                            {this.state.publishableKey && <React.Fragment>
                                <button className="btn btn-primary" onClick={this.chargeCreditCard} style={{ marginLeft: 10 }}>Credit Card Charge</button>
                            </React.Fragment>}
                        </div>
                    </div>
                </div>
            </div>
            <div id="altInvoiceModal" className="modal fade bd-altinvoice-modal-lg" tabIndex={-1} role="dialog">
                <div className="modal-dialog modal-lg" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Alt. Invoice Number</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="form-group">
                                <input
                                    className="form-control"
                                    type="text"
                                    maxLength={20}
                                    placeholder="Alternate Invoice #"
                                    value={this.state.altInvoiceNum}
                                    onChange={(e) => this.setState({ altInvoiceNum: e.target.value })}
                                />
                            </div>
                            {this.state.invoice &&
                                <LoadingButton className="btn btn-success" onClick={this.saveAltInvoiceNum} isLoading={this.state.isSaving}>{(this.state.invoice.AltInvoiceNum) ? "Change Alt. Invoice #" : "Add Alt. Invoice #"}</LoadingButton>
                            }
                        </div>
                    </div>
                </div>
            </div>
            {this.state.invoice && <Invoice invoice={this.state.invoice} />}
        </React.Fragment>
    }

    private myInvoiceCallback = (result: InvoiceSearchResult) => {
        this.setState({
            amount: (result.InvoiceID == -1) ? 0 : result.Amount,
            invoiceId: result.InvoiceID
        });
    };

    private handleSourceChange(e: DropDownListChangeEvent) {
        this.setState({ source: e.target.value.value });
    }

    private handleFacilityChange(e: DropDownListChangeEvent) {
        this.setState({ facilityID: e.target.value.ID });
    }

    public componentWillMount() {
        // This method runs when the component is first added to the page
        let invoiceId = parseInt(this.props.match.params.invoiceId) || 0;
        this.requestInvoice(invoiceId);
    }

    public componentWillReceiveProps(nextProps: Props) {
        // This method runs when incoming props (e.g., route params) change
        let invoiceId = parseInt(nextProps.match.params.invoiceId) || 0;

        if (this.state.invoice && this.state.invoiceId != invoiceId) {
            this.requestInvoice(invoiceId);
        }
    }

    public reviseInvoice() {
        if (this.state.invoiceId > 0 && this.state.isLoading == false) {
            this.setState({ isLoading: true });
            fetchApi(`api/Billing/ReviseInvoice/${this.state.invoiceId}`, {}, 'POST')
                .then(() => {
                    this.props.history.goBack();
                })
                .catch(() => {
                    alert("Unable to revise invoice!");
                })
                .finally(() => {
                    this.setState({ isLoading: false });
                });
        }
    }

    public emailInvoice() {
        if (this.state.invoiceId > 0&& this.state.isLoading == false) {
            this.setState({ isLoading: true });
            fetchApi(`api/Billing/EmailInvoice/${this.state.invoiceId}`, {}, 'POST')
                .then(() => {
                    alert("Invoice Successfully Emailed!");
                })
                .catch(() => {
                    alert("Unable to email invoice!");
                })
                .finally(() => {
                    this.setState({ isLoading: false });
                });
        }
    }

    public requestInvoice(invoiceId: number) {
        fetchApi(`api/Billing/Invoice/${invoiceId}`)
            .then((invoice: InvoiceData) => {
                this.setState({ invoice, invoiceId, accountId: invoice.AccountID, amount: invoice.TotalDue, altInvoiceNum: invoice.AltInvoiceNum });
            });

        fetchApi(`api/Facilities/List`)
            .then((facilities: FacilitySearchResult[]) => {
                this.setState({
                    facilities: facilities,
                    facilityID: parseInt(localStorage.getItem("FACILITY_ID") || "0") || undefined
                });
            });

        fetchApi(`api/Stripe/GetPublishableKey`)
            .then((response: string) => { this.setState({ publishableKey: response })});
    }

    private save() {
        if (this.state.facilityID === -1 || this.state.source === -1 || !this.state.amount || this.state.date === null) {
            this.setState({ validation: true })
            return;
        }

        this.setState({ isSaving: true });

        const data = {
            FacilityID: this.state.facilityID,
            Source: this.state.source,
            Amount: this.state.amount,
            Comment: this.state.comment,
            Date: this.state.date,
            InvoiceId: this.state.invoiceId
        }

        fetchApi(`api/Account/AddPayment/${this.state.accountId}`, data, 'POST')
            .then(() => {
                $("#paymentModal").modal('hide');
                this.setState({ amount: 0, comment: '', validation: false, isSaving: false });
            });
    }

    private chargeCreditCard()
    {
        if (this.state.facilityID === -1 || this.state.source === -1 || !this.state.amount || this.state.date === null) {
            this.setState({ validation: true })
            return;
        }

        const data = {
            FacilityID: this.state.facilityID,
            Source: this.state.source,
            Amount: this.state.amount,
            Comment: this.state.comment,
            ChargeDescription: this.state.chargeDescription,
            Date: this.state.date,
            InvoiceId: this.state.invoiceId
        }

        fetchApi(`api/Account/CreateStripeSession/${this.state.accountId}`, data, 'POST')
            .then((response) => {
                console.log(response);
                var stripe = Stripe(this.state.publishableKey)
                stripe.redirectToCheckout({
                    sessionId: response.sessionId
                }).then((result : any) => {
                    console.log(result);
                });
            });
    }

    private saveAltInvoiceNum() {
        var re = /^[a-z0-9\-]+$/i;
        if (!re.test(this.state.altInvoiceNum))
        {
            alert("Alt Invoice Number can only contain alphanumeric characters and a dash (-)");
            return;
        }

        const data = {
            AltInvoiceNum: this.state.altInvoiceNum,
            InvoiceId: this.state.invoiceId
        };

        fetchApi(`api/Account/AddAltInvoiceNum`, data, 'POST')
            .then((response: JsonResponse) => {
                if (response.Success) {
                    $("#altInvoiceModal").modal('hide');
                    this.requestInvoice(this.state.invoiceId);
                } else {
                    alert(response.ErrorMessage);
                    $("#altInvoiceModal").modal('hide');
                }
            });
    }
}
